// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueCookies from "vue-cookies"
import 'babel-polyfill'
import loadJS from 'load-js';


Vue.use(VueCookies);

Vue.config.productionTip = false

loadJS([
  {
    url: 'https://openmonitor.alipay-eco.com/cloudadmin/alipayLogger.js',
    async: true
  }
]).then(() => {
  Log('loadJS ok', __bl)
  init();
}).catch(() => {
  Log('loadJS Error')
  init();
})

function init() {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    template: '<App/>',
    components: {App}
  })
}



// WEBPACK FOOTER //
// ./src/main.js